import { guardEmptyString, guardUnspecified } from '@portal/utils/util-guards';
import { componentFactoryOf } from 'vue-tsx-support';

import { JtnUiRecordStatistics } from '../../_record/jtn-ui-record-statistics';
import { JtnUiAvatar } from '../../jtn-ui-avatar';
import { JtnUiImage } from '../../jtn-ui-image';

import styles from './jtn-ui-news-slider-item.styles.scss?module';

type Link = {
  title: string;
  url: string;
};

type ImageSource = {
  srcset: string;
  type?: string;
};

type Author = {
  id: number;
  image: { src: string; size: number; sources: ImageSource[] } | null;
  jobPosition: string;
  name: string;
  url: string;
};

type Events = {
  onTopLinkClicked: Event;
  onAuthorClicked: Event;
  onRecordClicked: Event;
  onCommentsClicked: Event;
  onDiscussClicked: Event;
};

const AVATAR_SIZE = 48;

export default componentFactoryOf<Events>().create({
  name: 'JtnUiNewsSliderItem',
  props: {
    topLinks: {
      type: Array as () => Link[],
      default: []
    },
    header: {
      type: String,
      default: ''
    },
    url: {
      required: true,
      type: String,
      default: ''
    },
    commentsUrl: {
      type: String,
      default: ''
    },
    discussUrl: {
      type: String,
      default: ''
    },
    commentsCount: {
      type: Number,
      default: 0
    },
    isCommentsAllowed: {
      type: Boolean,
      default: true
    },
    viewsCount: {
      type: Number,
      default: 0
    },
    author: {
      type: Object as () => Author | null,
      default: null
    }
  },
  render() {
    const url = this.author?.url;
    const NAME_TAG = guardUnspecified(url) && guardEmptyString(url) ? 'a' : 'span';

    const nameTagAttrs: {
      href?: string;
      target?: string;
    } = {};

    if (NAME_TAG === 'a') {
      nameTagAttrs.href = url;
      nameTagAttrs.target = '_self';
    }

    const nameText = guardUnspecified(this.author?.name)
      ? (this.author?.name as string)
      : 'Анонимное мнение';

    const jobPositionText = guardUnspecified(this.author?.jobPosition)
      ? (this.author?.jobPosition as string)
      : '';

    return (
      <div class={styles.item}>
        <div class={styles.topLinks}>
          {this.topLinks.map(link => (
            <a
              href={link.url}
              class={styles.topLink}
              target="_self"
              key={link.title}
              onClick={(event: Event) => this.$emit('topLinkClicked', event)}
            >
              {link.title}
            </a>
          ))}
        </div>
        <a
          href={this.url}
          class={styles.header}
          target="_self"
          onClick={(event: Event) => this.$emit('recordClicked', event)}
        >
          {this.header}
        </a>
        <NAME_TAG
          href={nameTagAttrs.href}
          target={nameTagAttrs.target}
          class={styles.author}
          onClick={(event: Event) => this.$emit('authorClicked', event)}
        >
          <JtnUiAvatar
            size={AVATAR_SIZE}
            isSquare={true}
            nativeOnClick={(event: Event) => {
              this.$emit('toProfile', event);
            }}
          >
            {guardUnspecified(this.author?.image) && (
              <JtnUiImage
                slot="photo"
                src={this.author?.image.src}
                sources={this.author?.image.sources}
                width={this.author?.image.size}
                height={this.author?.image.size}
                loading="lazy"
                decoding="async"
                alt="Фото автора"
              />
            )}
          </JtnUiAvatar>
          <div class={styles.authorInfo}>
            <p class={styles.authorName}>{nameText}</p>
            {guardEmptyString(jobPositionText) && (
              <p class={styles.authorJob}>{jobPositionText}</p>
            )}
          </div>
        </NAME_TAG>
        <JtnUiRecordStatistics
          class={styles.statisticBlock}
          commentsCount={this.commentsCount}
          commentsUrl={this.commentsUrl}
          discussUrl={this.discussUrl}
          isCommentsAllowed={this.isCommentsAllowed}
          viewsCount={this.viewsCount}
          onCommentsClicked={(event: Event) => this.$emit('commentsClicked', event)}
          onDiscussClicked={(event: Event) => this.$emit('discussClicked', event)}
        />
      </div>
    );
  }
});
